module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-default-vertical-logotype.e8ae4e47.svg";